import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

import type { CsvExportResponse } from '@/types/shortUrl'

const companyProfilesApi = createAggrApiInstance(aggr.CompanyProfilesApi)

export const queryAllCompanyProfiles = async (reqData: aggr.ProfileQueryAllRq) => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesQueryall(reqData))
  return res
}

export const querySubtotal = async (reqData: aggr.ProfileQuerySubtotalRq) => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesQuerysubtotal(reqData))
  return res
}

export const queryCompanyInfo = async (componyUuid: string) => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesQuery(componyUuid))
  return res
}

export const createCompanyProfile = async (reqData: aggr.ProfileUpdateRq) => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesCreate(reqData))
  return res
}

export const updateCompanyProfile = async (reqData: aggr.ProfileUpdateRq) => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesUpdate(reqData))
  return res
}

export const enableCompanyProfile = async (companyUuid: string) => {
  const profileEnableRq: aggr.ProfileEnableRq = {
    companyUuid: companyUuid
  }
  const res = await handleApiStatus(() => companyProfilesApi.profilesEnable(profileEnableRq))
  return res
}

export const disableCompanyProfile = async (companyUuidList: Array<string>) => {
  const reqData: aggr.ProfileDisableRq = {
    companyUuidList: companyUuidList
  }
  const res = await handleApiStatus(() => companyProfilesApi.profilesDisable(reqData))
  return res
}

export const exportAll = async (reqData: aggr.ProfileExportAllRq): Promise<CsvExportResponse> => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesExportall(reqData))
  return res as unknown as CsvExportResponse
}

export const exportSelected = async (reqData: aggr.ProfileExportSelectedRq): Promise<CsvExportResponse> => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesExportselected(reqData))
  return res as unknown as CsvExportResponse
}

export const queryCompanyDomains = async (companyUuid: string) => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesQuerydomains(companyUuid))
  return res
}

export const addCompanyDomain = async (reqData: aggr.ProfileAddDomainRq) => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesAddcompanydomain(reqData))
  return res
}

export const updateCompanyDomain = async (reqData: aggr.ProfileUpdateDomainRq) => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesUpdatecompanydomain(reqData))
  return res
}

export const removeCompanyDomain = async (reqData: aggr.ProfileRemoveDomainRq) => {
  const res = await handleApiStatus(() => companyProfilesApi.profilesRemovedomain(reqData))
  return res
}
